import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  TActiveServiceAlertResponse,
  TActiveServiceAlertsParams,
} from './types';

export function useActiveServiceAlerts(
  params: TActiveServiceAlertsParams | null | undefined
) {
  let key: string | null = null;

  if (params !== null) {
    const qs = new URLSearchParams();
    if (params?.serviceCompositeId)
      qs.append('serviceCompositeId', params.serviceCompositeId);
    const query = qs.toString();
    key = query ? `service-alerts/active?${query}` : 'service-alerts/active';
  }

  const { data, error, isLoading, mutate } =
    useSWR<TActiveServiceAlertResponse>(key, SWRFetcher({ method: 'GET' }));

  return { data, error, isLoading, mutate };
}
